import { appConfig } from '@root/config';
import { APP_TOKEN_KEY, INSTANT_GAME } from '@root/constants';

// Operator's game list. Also the only deposit route we have.
export function exitToLobby(): void {
  const params = new URLSearchParams({
    type: INSTANT_GAME,
    authtoken: localStorage.getItem(APP_TOKEN_KEY) || '',
  });
  window.location.href = `${appConfig.apiConfig.tristarGamesHost}/games?${params.toString()}`;
}
